import { IELanguages } from 'i18n/@types';
import { IEventEventProvider, IEventEventProviderParams } from 'lib/EventsProvider/@types';
import {
  IE_CREATE_BABY_KINEDU_TYPE,
  IE_LOAD_DEFAULT_PAYWALL_FOLDER,
  IE_PP_PAYMENT_STARTED_PROVIDER,
  IPP_PAYMENT_STARTED,
} from './@types';

const COMPLETE_REGISTRATION = (): IEventEventProvider => ({ tag: 'CompleteRegistration' });

const SIGNUP_SCREEN = (): IEventEventProvider => ({ tag: 'S_SPSignUp' });

const SELECT_LANGUAGE = (language: IELanguages): IEventEventProvider => ({
  tag: 'SelectLanguage',
  params: {
    source: 'ob',
    language,
  },
});

const SIGNUP = (): IEventEventProvider => ({
  tag: 'Signup',
  params: {
    signInProvider: 'kinedu',
  },
});
const SIGNUP_ERROR = (error: IEventEventProviderParams | undefined): IEventEventProvider => ({
  tag: 'SignupError',
  params: {
    ...error,
    signInProvider: 'kinedu',
  },
});

const S_OB_CREATE_USER = (): IEventEventProvider => ({ tag: 'S_OBCreateUser' });

const OB_CREATE_USER = (): IEventEventProvider => ({ tag: 'OBCreateUser' });

const S_OB_CREATE_BABY = (): IEventEventProvider => ({ tag: 'S_OBCreateBaby' });

const OB_CREATE_TWINS = (): IEventEventProvider => ({ tag: 'OBCreateTwins' });

const CREATE_BABY = (ky: IE_CREATE_BABY_KINEDU_TYPE = IE_CREATE_BABY_KINEDU_TYPE.KINEDU): IEventEventProvider => ({
  tag: 'CreateBaby',
  params: {
    source: 'ob',
    kinedu_type: ky,
  },
});

const LOAD_DEFAULT_PAYWALL = (
  attrs: string,
  folder: IE_LOAD_DEFAULT_PAYWALL_FOLDER = IE_LOAD_DEFAULT_PAYWALL_FOLDER.BORN,
): IEventEventProvider => ({
  tag: 'LoadDefaultPaywall',
  params: {
    folder,
    variable: attrs,
  },
});

const LOAD_DEFAULT_PP = (attrs: string): IEventEventProvider => ({
  tag: 'LoadDefaultPP',
  params: {
    folder: 'webPP',
    variable: attrs,
  },
});

const PAYWALL_DISMISS = (): IEventEventProvider => ({ tag: 'PaywallDismiss' });

const S_PAYWALL = (): IEventEventProvider => ({ tag: 'S_Paywall' });

const PP_PAYMENT_STARTED = ({
  paymentSource,
  type,
  subscriptionType,
  paymentPath,
  sku,
  provider = IE_PP_PAYMENT_STARTED_PROVIDER.STRIPE,
}: IPP_PAYMENT_STARTED): IEventEventProvider => ({
  tag: 'PPPaymentStarted',
  params: {
    type,
    sku,
    subscription_type: subscriptionType,
    payment_source: paymentSource,
    payment_path: paymentPath,
    provider,
  },
});

const FREE_TRIAL_START = (): IEventEventProvider => ({ tag: 'FreeTrialStart' });

const S_FROM_QUIZ = ({
  email,
  source = 'webQuizPaywall',
  from,
}: {
  email: string;
  source: string;
  from?: string;
}): IEventEventProvider => ({
  tag: 'S_FromQuiz',
  params: {
    email,
    source,
    from,
  },
});

const FAILURE_VERIFY_FORMSTACK_USER = (email: string): IEventEventProvider => ({
  tag: 'FailureVerifyFormstackUser',
  params: { email },
});

const START_WEB_QUIZ = (source = 'LandingPage'): IEventEventProvider => ({
  tag: 'StartWebQuiz',
  params: { source },
});

const S_PREMIUM_PROCESS = (): IEventEventProvider => ({
  tag: 'S_PremiumProcess',
});

const PP_PAYMENT_CANCELED = (): IEventEventProvider => ({
  tag: 'PPPaymentCanceled',
});

const S_WEB_CHAT_IA = (): IEventEventProvider => ({ tag: 'S_WebChatIA' });

const WRITE_QUESTION = (source = 'WebChatIA'): IEventEventProvider => ({
  tag: 'WriteQuestion',
  params: { source },
});

const SELECT_PROMPT = ({ question, answer }: { question: string; answer: string | number }): IEventEventProvider => ({
  tag: 'SelectPrompt',
  params: { question, answer },
});

// const WEB_CHATIA_MEGER_EVENTS = (): IEventEventProvider => ({
//   tag: 'WebChatIAMegerEvents',
// });

const WEB_CHATIA_MEGER_EVENTS = (userId: string, source: string): IEventEventProvider => ({
  tag: 'WebChatIAMegerEvents',
  params: { userId, source },
});

export default {
  COMPLETE_REGISTRATION,
  SIGNUP_SCREEN,
  SELECT_LANGUAGE,
  SIGNUP,
  SIGNUP_ERROR,
  S_OB_CREATE_USER,
  OB_CREATE_USER,
  S_OB_CREATE_BABY,
  OB_CREATE_TWINS,
  CREATE_BABY,

  LOAD_DEFAULT_PAYWALL,
  LOAD_DEFAULT_PP,
  PAYWALL_DISMISS,
  S_PAYWALL,
  PP_PAYMENT_STARTED,
  FREE_TRIAL_START,
  S_FROM_QUIZ,
  FAILURE_VERIFY_FORMSTACK_USER,
  START_WEB_QUIZ,
  S_PREMIUM_PROCESS,
  PP_PAYMENT_CANCELED,
  S_WEB_CHAT_IA,
  WRITE_QUESTION,
  SELECT_PROMPT,
  WEB_CHATIA_MEGER_EVENTS,
};
